import Cookies from 'js-cookie'

export const checkPathPresent = (arrayOfPaths, pathname) => {
  return arrayOfPaths.some((path) => pathname.includes(path))
}

export const pluralizeString = (string, array) => array.length > 1 ? `${string}s` : string

export const logoutUser = () => Cookies.remove('token')

export const isPastTime = (time) => {
  const currentTimeInSeconds = Math.floor(Date.now() / 1000)
  return time < currentTimeInSeconds
}

export const isPastDate = (dateValue) => {
  const date = new Date(dateValue)
  const currentDate = new Date()
  return date < currentDate
}

const UTM_MAP = {
  utm_source: 'source',
  utm_medium: 'medium',
  utm_campaign: 'campaign',
  utm_term: 'term',
  utm_content: 'content'
}

const getUtmFromUrl = () => {
  if (typeof window === 'undefined') return {}
  const params = new URLSearchParams(window.location.search || '')
  const utm = {}
  Object.keys(UTM_MAP).forEach(key => {
    const value = params.get(key)
    if (value) utm[key] = value
  })
  return utm
}

export const saveUtmToCookie = () => {
  const utm = getUtmFromUrl()
  Object.entries(utm).forEach(([key, value]) => {
    const cookie = UTM_MAP[key]
    if (cookie) {
      Cookies.set(cookie, value, { expires: 7 }) // setting cookie expiration to 7 days
    }
  })
  return utm
}

export const getUtmFromCookie = () => {
  const utm = {}
  Object.entries(UTM_MAP).forEach(([key, cookie]) => {
    const value = Cookies.get(cookie)
    if (value) utm[key] = value
  })
  return Object.keys(utm).length ? utm : null
}
